
export async function fetchClientData(clientID) {
    const res = await fetch(
        "https://server.pabloo.com/website/get_client_data",
        {
            method: "POST",
            headers: {
                "accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ client_id: clientID, business: "herstory" }),
        }
    );
    if (!res.ok) throw new Error(`Failed to fetch client data: ${res.status}`);
    return res.json();
}
